import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import {
  Loop,
  Create,
  Layers,
  TableChart,
  Schedule,
  Details,
  BorderColor
} from "@material-ui/icons";

import Chat from "@material-ui/icons/Chat";

import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";


import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";

class SectionPhoto extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
              <h5 className={classes.description}>
              We offer our services to prepare master plan for urban planning,
              zoning plan and hard & soft scape plan. This will cover stages
              starting from conceptual design study to safe and convenient built
              environment. Moreover, we extend our services to provide full
              architectural design details (detail layout plans, elevations, and
              sections), fire escape provision, living space fully integrated
              with accessibility, architectural specifications and schedules.
           </h5>
          </GridItem>
        </GridContainer>
     
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Site Plan Analysis"
                 description="We offer Site Plan, Setback Requirements, Plot Ratio and Building Coverage."              
                icon={Loop}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Landscape Design"
                description="We offer Water Scape, Handscape & Softscape."
                icon={Create}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Greenery Provision"
                description="We offer necessary ingredient of environmental quality and quality of life."
                icon={AssignmentTurnedIn}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Detailed Drawings"
                description="We offer Room Layouts, Staircases, Doors & Windows, Concrete Masonry Unit (CMU) Wall & Dry Wall, Floor Finishes, Ceiling, Waterproofing, Fire Rated Details, Railing, Canopy & Cladding."
                icon={BorderColor}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Architectural Schedule"
                description="We offfer Door & Ironmongery Schedule, Room Finishes Schedule."
                icon={Schedule}
                iconColor="success"
                vertical
              />
            </GridItem>
          <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Architectural Specification"
                description="We could assist you with a range of requirements for your project including; specification support, project advice, BIM drawings or even just inspiration."
                icon={Details}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Sections"
                description="We offer Main Sections, Finished Floor Level (FFL) and Above Mean Sea Level (AMSL)."
                icon={TableChart}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Elevations"
                description="We offer All or Main Elevations, Finished Floor Level (FFL), Above Mean Sea Level (AMSL) and Unprotected Openings Calculation."
                icon={Layers}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="General Arrangement"
                description="We offer Floor Plans, Gross Floor Area, Floor Level, Complied Exit Distance and Fire Fighting System."
                icon={Chat}
                iconColor="success"
                vertical
              />

            </GridItem>         
         </GridContainer>   

        </div>
        </div>
    );
  }
}

export default withStyles(workStyle)(SectionPhoto);



// WEBPACK FOOTER //
// ./src/views/ArchiPage/Sections/SectionService.jsx